
// @ts-nocheck
import locale__vercel_path0_lang_de_json from "../lang/de.json";
import locale__vercel_path0_lang_fr_json from "../lang/fr.json";


export const localeCodes =  [
  "de",
  "fr"
]

export const localeLoaders = {
  "de": [{ key: "../lang/de.json", load: () => Promise.resolve(locale__vercel_path0_lang_de_json), cache: true }],
  "fr": [{ key: "../lang/fr.json", load: () => Promise.resolve(locale__vercel_path0_lang_fr_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "de",
      "name": "Deutsch",
      "iso": "de-CH",
      "files": [
        "lang/de.json"
      ]
    },
    {
      "code": "fr",
      "name": "Français",
      "iso": "fr-CH",
      "files": [
        "lang/fr.json"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "de",
    "name": "Deutsch",
    "iso": "de-CH",
    "files": [
      {
        "path": "lang/de.json"
      }
    ]
  },
  {
    "code": "fr",
    "name": "Français",
    "iso": "fr-CH",
    "files": [
      {
        "path": "lang/fr.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
